import Phaser from "phaser"
// @ts-ignore
let startButton
export default class StartScene extends Phaser.Scene {

    constructor() {
        super('start-scene')
    }

    init(data)
    {
        this.score = data.score
        this.startSound = undefined
    }

    preload() {
        this.load.image('bg-start', 'images/start_bg.jpg')

        this.load.image('start-button', 'images/start_button.png')

        this.load.image('title', 'images/title.png')

        this.load.audio('startSound', 'sfx/backsound/BravePilots.ogg')
    }

    create(){
        this.add.image(200, 320, 'bg-start').setScale(0.5)
        this.add.image(200, 120, 'title')
 

        this.replayButton = this.add.image(210, 335, 'start-button').setInteractive().setScale(0.5)

        // ketika di klik, scene akan berpindah ke CoronaBusterScene
        this.replayButton.once('pointerup', () => {
            this.scene.start('hunting-alien-io')
            this.startSound.stop()
        }, this)

        this.startSound = this.sound.add('startSound')
        var soundConfig = {
            loop : true,
            volume : 0.3
        }
        this.startSound.play(soundConfig)
    }
}